import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import StoryCard from './StoryCard';
import ModalPage from './ModalPage';
import useDataFetch from '../hooks/useDataFetch';
import axios from 'axios';

const StoryPage = () => {
  const { articleId } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [authUser, setAuthUser] = useState(null);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const res = await axios.get('/api/auth/me');
        setAuthUser(res.data || null);
      } catch (error) {
        setAuthUser(null);
      }
    };
    checkAuth();
  }, []);

  const fetchStory = async () => {
    const summaryId = searchParams.get('summary');
    const storyUrl = summaryId
      ? `/api/story/${articleId}?summary=${encodeURIComponent(summaryId)}`
      : `/api/story/${articleId}`;
    const response = await fetch(storyUrl);
    if (!response.ok) {
      throw new Error('Failed to fetch story');
    }
    return response.json();
  };

  const { data: story, loading, error } = useDataFetch(fetchStory, [articleId, searchParams.toString()]);

  const handleClose = () => {
    navigate('/');
  };

  return (
    <ModalPage
      title={story?.article?.title || story?.ai_takeaway_title || 'Story'}
      loading={loading}
      error={error}
      notFound={!loading && !error && !story}
      onClose={handleClose}
    >
      <section className="briefing-section">
        <h2 className="briefing-section-title">Story Details</h2>
        <div className="stories-container">
          <StoryCard 
            story={story} 
            type={story?.type || 'insight'}
            isPublic={true}
            authUser={authUser}
          />
        </div>
      </section>
    </ModalPage>
  );
};

export default StoryPage;